import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import './NoteWindow.css'

import closeIcon from '../../../assets/icons/close-icon.svg'
import maximizeIcon from '../../../assets/icons/fullscreen-icon.svg'
import minimizeIcon from '../../../assets/icons/minscreen-icon.svg'
import editIcon from '../../../assets/icons/Notes/edit-square-icon.svg'
import saveIcon from '../../../assets/icons/Notes/save-icon.png'
import cancelIcon from '../../../assets/icons/Notes/cancel-icon.png'
import { useOrientation } from '../../../contexts/OrientationContext'

function NoteWindow({ onClose }) {
  const { isPortrait } = useOrientation()
  const [isMaximized, setIsMaximized] = useState(false)
  const [notes, setNotes] = useState([
    {
      id: 1,
      content:
        '关于我\n\n一个上班写代码、下班带娃、\n喜欢推理小说和NS端游戏、\n偶尔在云上部署理想、\n偶尔在现实中 debug 生活的全栈工程师。\n擅长把复杂的东西做简单，也擅长在混乱中找到秩序。',
      date: new Date().toLocaleDateString('zh-CN'),
    },
    {
      id: 2,
      content:
        'About Me\n\nA full-stack engineer who codes at work and takes care of a kid after hours.\nA fan of detective novels, as well as Nintendo Switch games.\nOccasionally deploying ideals in the cloud,\nand debugging life in the real world.\nGood at simplifying complex problems and finding order in chaos.',
      date: new Date().toLocaleDateString('zh-CN'),
    },
  ])
  const [selectedNote, setSelectedNote] = useState(notes[0])
  const [isEditing, setIsEditing] = useState(false)
  const [editContent, setEditContent] = useState('')
  const [contextMenu, setContextMenu] = useState(null)

  const toggleMaximize = () => {
    setIsMaximized(!isMaximized)
  }

  const handleNoteClick = note => {
    setSelectedNote(note)
    setIsEditing(true)
    setEditContent(note.content)
  }

  const handleEdit = () => {
    setIsEditing(true)
    setEditContent(selectedNote.content)
  }

  const handleSave = () => {
    const updatedNotes = notes.map(note =>
      note.id === selectedNote.id ? { ...note, content: editContent } : note
    )
    setNotes(updatedNotes)
    setSelectedNote({ ...selectedNote, content: editContent })
    setIsEditing(false)
  }

  const handleNewNote = () => {
    const newNote = {
      id: Date.now(),
      content: '',
      date: new Date().toLocaleDateString('zh-CN'),
    }
    setNotes([newNote, ...notes])
    setSelectedNote(newNote)
    setIsEditing(true)
    setEditContent('')
  }

  const handleContextMenu = (e, note) => {
    e.preventDefault()
    setContextMenu({
      x: e.clientX,
      y: e.clientY,
      noteId: note.id,
    })
  }

  const handleDeleteFromContext = noteId => {
    const noteToDelete = notes.find(note => note.id === noteId)
    if (noteToDelete) {
      const updatedNotes = notes.filter(note => note.id !== noteId)
      setNotes(updatedNotes)
      if (selectedNote?.id === noteId) {
        if (updatedNotes.length > 0) {
          setSelectedNote(updatedNotes[0])
        } else {
          setSelectedNote(null)
        }
        setIsEditing(false)
      }
    }
    setContextMenu(null)
  }

  const handleClickOutside = () => {
    setContextMenu(null)
  }

  useEffect(() => {
    if (contextMenu) {
      document.addEventListener('click', handleClickOutside)
      return () => {
        document.removeEventListener('click', handleClickOutside)
      }
    }
  }, [contextMenu])

  return (
    <div className={`note-window-overlay ${isPortrait ? 'portrait' : ''}`}>
      <div className={`note-window ${isMaximized ? 'maximized' : ''}`}>
        <div className="note-window-sidebar">
          <div className="note-window-buttons">
            <img
              className="close-icon"
              onClick={onClose}
              src={closeIcon}
              alt="Close"
              style={{ cursor: 'pointer', width: '12px', height: '12px' }}
            />
            <img
              className="close-icon"
              onClick={toggleMaximize}
              src={isMaximized ? minimizeIcon : maximizeIcon}
              alt="Toggle"
              style={{ cursor: 'pointer', width: '12px', height: '12px' }}
            />
          </div>
          <div className="note-list">
            {notes.map(note => {
              // 从content的第一行提取title，如果没有换行符则使用前50个字符
              const firstLine = note.content.split('\n')[0]
              const title =
                firstLine || note.content.substring(0, 50) || '新笔记'
              const displayTitle =
                title.length > 50 ? title.substring(0, 50) + '...' : title

              return (
                <div
                  key={note.id}
                  className={`note-list-item ${
                    selectedNote?.id === note.id ? 'active' : ''
                  }`}
                  onClick={() => handleNoteClick(note)}
                  onContextMenu={e => handleContextMenu(e, note)}
                >
                  <div className="note-list-item-preview">{displayTitle}</div>
                  <div className="note-list-item-date">{note.date}</div>
                </div>
              )
            })}
          </div>
          {contextMenu && (
            <div
              className="note-context-menu"
              style={{
                position: 'fixed',
                top: contextMenu.y,
                left: contextMenu.x,
              }}
              onClick={e => e.stopPropagation()}
            >
              <button
                className="context-menu-delete-button"
                onClick={() => handleDeleteFromContext(contextMenu.noteId)}
              >
                Delete
              </button>
            </div>
          )}
        </div>
        <div className="note-window-content">
          {selectedNote ? (
            <>
              {isEditing ? (
                <div className="note-editor">
                  <div className="note-viewer-header">
                    <button className="edit-button" onClick={handleNewNote}>
                      <img
                        src={editIcon}
                        alt="Edit"
                        style={{ width: '16px', height: '16px' }}
                      />
                    </button>
                    <div className="note-editor-actions">
                      <button className="save-button" onClick={handleSave}>
                        <img
                          src={saveIcon}
                          alt="Save"
                          style={{ width: '16px', height: '16px' }}
                        />
                      </button>
                      <button
                        className="cancel-button"
                        onClick={() => setIsEditing(false)}
                      >
                        <img
                          src={cancelIcon}
                          alt="Cancel"
                          style={{ width: '16px', height: '16px' }}
                        />
                      </button>
                    </div>
                  </div>
                  <textarea
                    className="note-editor-content"
                    value={editContent}
                    onChange={e => setEditContent(e.target.value)}
                    placeholder="开始输入..."
                    autoFocus
                  />
                </div>
              ) : (
                <div className="note-viewer">
                  <div className="note-viewer-header">
                    <button className="edit-button" onClick={handleNewNote}>
                      <img
                        src={editIcon}
                        alt="Edit"
                        style={{ width: '16px', height: '16px' }}
                      />
                    </button>
                  </div>
                  <div
                    className="note-viewer-content"
                    onClick={handleEdit}
                    style={{ cursor: 'text' }}
                  >
                    {selectedNote.content}
                  </div>
                </div>
              )}
            </>
          ) : (
            <div className="note-empty-state">
              <p>没有笔记</p>
              <button className="new-note-button" onClick={handleNewNote}>
                创建新笔记
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

NoteWindow.propTypes = {
  onClose: PropTypes.func.isRequired,
}

export default NoteWindow
